const SliderCard = ({ label, value, setValue, min, max, step = 1, role }) => {
  const handleInputChange = (e) => {
    let val = e.target.value;

    // Prevent non-numeric or out-of-range input
    if (val === "") {
      setValue("");
      return;
    }

    let num = Number(val);
    if (isNaN(num)) return;

    // Clamp to min/max
    if (num < min) num = min;
    if (num > max) num = max;

    setValue(num);
  };

  return (
    <div className="slider-card">
      <div
        style={{
          flexDirection: "row",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          marginBottom:role === "User"?"10px":"-10px"
          
        }}
      >
        <p className="slider-label">
          {label}:{/* {value || "0"}</input> */}{role === "User"?value:null}
        </p>
  
         {role === "User" ? null :
            <input
          type="number"
          className="slider-value"
          value={value}
          min={min}
          max={max}
          step={step}
          style={{
            width: "70px",
            textAlign: "center",
            border: "1px solid #ccc",
            borderRadius: "4px",
            padding: "4px",
          }}
          onChange={handleInputChange}
        />
}
      </div>
      {role === "User" ? null : (
        <>
          <input
            type="range"
            value={value||0}
            min={min}
            max={max}
            step={step}
            onChange={(e) => setValue(e.target.value)}
            className="slider-input"
          />
          <div className="slider-range">
            <span>{min}</span>
            <span>{max}</span>
          </div>
        </>
      )}
    </div>
  );
};

export default SliderCard;
